import { render, staticRenderFns } from "./hotelSourceList.vue?vue&type=template&id=b354e784&scoped=true"
import script from "./hotelSourceList.vue?vue&type=script&lang=js"
export * from "./hotelSourceList.vue?vue&type=script&lang=js"
import style0 from "./hotelSourceList.vue?vue&type=style&index=0&id=b354e784&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b354e784",
  null
  
)

export default component.exports